import { type FC } from 'react'
import { StoredEmailPreview } from '../EmailTemplateEditor/StoredEmailPreview'
import { TemplateNoticeBox } from '../TemplateEditorBox'
import { SCHEDULING_VIEW_ONLY_TEXT } from '../templateEditorMessages'

export interface SchedulingEmailViewBoxProps {
  template: unknown
}

export const SchedulingEmailViewBox: FC<SchedulingEmailViewBoxProps> = ({ template }) => (
  <TemplateNoticeBox text={SCHEDULING_VIEW_ONLY_TEXT}>
    <StoredEmailPreview template={template} />
  </TemplateNoticeBox>
)
